module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_0.79574385.png";